import {Model} from "@/services/api";

export default class Lafil014 extends Model {
    static relations = {
        lafil013: require("@/services/models/lafil013").default,
        notebook: require("@/services/models/notebook").default
    };

    toString() {
        return this.Code;
    }

    static route() {
        return 'lafil014';
    }

    static primaryKey() {
        return 'Code';
    }
}
